import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const WaveLayerSpinSpeedListItem = ({ speed, index, updateWaveLayerSpinSettings }) => {
    const onSpeedChange = (value) => {
        previewHistoryBatch.start();
        updateWaveLayerSpinSettings(index, "speed", value);
    };

    return (
        <SliderListItem
            title='Speed'
            value={speed}
            displayMultiplier={1}
            min={-100}
            max={100}
            step={1}
            onValueChange={onSpeedChange}
        />
    );
};

const mapStateToProps = (state, { index }) => {
    const spinSettings = state.createPreview.present.videoSettings.visualizer.waveCircles[index]?.customOptions?.spinSettings;
    return { speed: spinSettings?.speed ?? 0 };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerSpinSettings: (index, key, value) => dispatch(createActions.updateWaveLayerSpinSettings(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerSpinSpeedListItem);